import { styled } from '@mui/material/styles'

export const Footer = styled('div', {
  name: 'Footer',
  slot: 'Root',
  skipSx: true,
})`
  display: flex;
  justify-content: flex-end;
  border-top: 1px ridge lightgray;
  padding-right: 25px;
`
